'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_samples$002e$002dPersons$0024package$0024$002dPerson$00241 from "./samples.-Persons$package$-Person$1.js";
var $p;
/** @constructor */
function $c_Lsamples_Persons$package$Person$3$() {
}
export { $c_Lsamples_Persons$package$Person$3$ as $c_Lsamples_Persons$package$Person$3$ };
$p = $c_Lsamples_Persons$package$Person$3$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Persons$package$Person$3$;
/** @constructor */
function $h_Lsamples_Persons$package$Person$3$() {
}
export { $h_Lsamples_Persons$package$Person$3$ as $h_Lsamples_Persons$package$Person$3$ };
$h_Lsamples_Persons$package$Person$3$.prototype = $p;
$p.b = (function() {
  return "Person";
});
$p.UA = (function(x$0) {
  return new $j_samples$002e$002dPersons$0024package$0024$002dPerson$00241.$c_Lsamples_Persons$package$Person$1(x$0.g(0), x$0.g(1), x$0.g(2), x$0.g(3), x$0.g(4), x$0.g(5), x$0.g(6), (+x$0.g(7)));
});
$p.y = (function(p) {
  return this.UA(p);
});
var $d_Lsamples_Persons$package$Person$3$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Persons$package$Person$3$, "samples.Persons$package$Person$3$", ({
  q9: 1,
  e: 1,
  g: 1
}));
export { $d_Lsamples_Persons$package$Person$3$ as $d_Lsamples_Persons$package$Person$3$ };
